<template>
    <div class="game_view" :class="[lang]">
        <div class="game_tap_mask" @click="viewTap" v-show="showMask"></div>
        <!-- 弹窗 -->
        <popup v-show="!showDownloadPop && isPopup" />
        <!-- 动画舞台 -->
        <div id="animation_container">
            <canvas
                id="canvas"
                width="596"
                height="807"
                style="position: absolute; display: block"
            ></canvas>
            <div
                id="dom_overlay_container"
                style="
                    pointer-events: none;
                    overflow: hidden;
                    width: 596px;
                    height: 807px;
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    display: block;
                "
            ></div>
        </div>
        <!-- slogan对话框 -->
        <div
            class="slogan_box"
            :class="[
                lang,
                {
                    show: gameview == 'home' || gameview == 'record1',
                    pos2: gameview == 'record1'
                }
            ]"
        >
            <div class="slogan_cont">
                <i class="i0"></i>
                <i class="i1"></i>
                <div class="slogan_top">
                    <i class="i2"></i>
                    <i class="i3"></i>
                </div>
                <p>
                    {{ slogan
                    }}<i class="i6"
                        ><img src="@/assets/img/game/icon_arrow.png" alt=""
                    /></i>
                </p>
                <div class="slogan_bottom">
                    <i class="i4"></i>
                    <i class="i5"></i>
                </div>
            </div>
        </div>
        <!-- 属性面板 -->
        <dragonInfoPanel
            :show="gameview == 'home' || gameview == 'create'"
            :tags="tags"
            :constellation="constellation"
        />
        <!-- pk记录 -->
        <div class="pk_text_wrap" :class="{ show: gameview == 'pk' }">
            <div class="pk_text_box" ref="pklist">
                <p v-for="item in pkwordsData" :key="item" v-html="item"></p>
            </div>
        </div>
        <!-- 登录后无PK记录提示 -->
        <div
            class="tips_no_record"
            :class="[lang, { show: gameview == 'record1' }]"
            v-html="$t('base.norecord_tips')"
        >
            <!-- <p>No friends have come yet.</p>
            <p>Tap the Share button to show off your Dragon</p>
            <p>and invite your friends to battle!</p> -->
        </div>
        <!-- 战力页部分 -->
        <powerTopBar :show="gameview == 'user'" />
        <powerBottomBar :show="gameview == 'user'" />
        <!-- 查看战力规则按钮 -->
        <div
            class="pop_score_rule"
            :class="{ show: gameview == 'user' }"
            @click="popScoreRule"
        >
            {{ $t('base.score_rule_btn') }}
        </div>
        <!-- 查看中奖记录 -->
        <div
            class="pop_reward_record"
            :class="{ show: gameview == 'user' }"
            @click="popRecord"
        >
            {{ $t('base.record_btn') }}
        </div>
        <!-- 下载弹窗 -->
        <div class="popDownload" v-show="gameview == 'popdownload'">
            <a
                href="javascript:void(0)"
                class="btn_close"
                @click="closePopDownload"
            ></a>
            <!-- 下载链接 -->
            <a
                href="javascript:void(0)"
                class="btn_download"
                @click="clickDownload"
                >{{ $t('base.download_btn') }}</a
            >
            <div class="talkbox">{{ $t('base.download_slogan') }}</div>
        </div>
        <!-- 分享图 -->
        <sharePicView :catchpic="gameviewpic" />
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import html2canvas from 'html2canvas';
import Base64 from '@/utils/base64js.min.js';
import { Bus } from '@/utils/eventBus.js';
import { getQueryString } from '../utils';
import Common from '../utils/common.js';
import i18n from '@/lang/index';
// components start
import popup from '@/components/popup';
import powerTopBar from '@/components/game/score-top-bar.vue';
import powerBottomBar from '@/components/game/score-bottom-bar.vue';
import dragonInfoPanel from '@/components/game/dragon-info-pannel.vue';
import sharePicView from '@/components/game/share-pic.vue';
// components end
// import 'script-loader!createjs/builds/1.0.0/createjs.min.js';
// import '../game/ani-test.js';
// import aniClass from '../game/game.js';
// window.gameAni = null;
export default {
    name: 'gameview',
    components: {
        popup,
        powerTopBar,
        powerBottomBar,
        dragonInfoPanel,
        sharePicView
    },
    data() {
        return {
            downloadLink: '', // 下载链接
            showDownloadPop: false, // 下载弹窗是否弹出
            hasUser: this.$store.state.game.nickname != '', // 是否输入了昵称
            nickname: this.$store.state.game.nickname, // 用户昵称
            slogan: '', // slogan
            dragonName: '', // 龙的名字
            tagsData: {}, // 可选标签
            tags: [], // 标签
            constellation: {}, // 星座
            showPkWords: false, // 是否显示pk文案
            pkwordsData: [], // pk对战文案
            gameviewpic: '' // 游戏屏幕截屏。用于合成分享图
        };
    },
    computed: {
        lang() {
            if (gameAni) {
                gameAni.lang = this.$store.state.lang;
            }
            return this.$store.state.lang;
        },
        showMask() {
            return (
                this.$store.state.game.view == 'home' ||
                this.$store.state.game.view == 'record1' ||
                this.$store.state.game.view == 'popwinner'
            );
        },
        // 是否有弹窗弹出，有，则隐藏mask层
        isPopup() {
            let _isPop = false;
            for (let key in this.$store.state.popup) {
                _isPop = this.$store.state.popup[key];
                if (_isPop) {
                    break;
                }
            }
            return _isPop;
        },
        // 游戏界面
        gameview() {
            // let _view = this.$store.state.game.view;
            return this.$store.state.game.view;
        }
    },
    watch: {},
    methods: {
        ...mapMutations([
            'SET_STATE',
            'SHOW_POPUP',
            'SET_LANG',
            'SET_GAME_STATE',
            'HIDE_ALL_POPUP',
            'SET_USERINFO',
            'PLAY_SOUND',
            'STOP_SOUND'
        ]),
        ...mapActions([
            'showComm',
            'getUserInfo',
            'confirmDragon',
            'getBattleResult',
            'getBattleHistoryList',
            'uploadImg',
            'popShareTips',
            'getDownloadScore'
        ]),
        // 屏幕点击事件
        viewTap() {
            // console.log('你点击了游戏屏幕');
            // 当前是home界面时，点击切换slogan
            if (this.gameview == 'home' || this.gameview == 'record1') {
                let _slogan = i18n.t('game.slogan');
                this.slogan = _slogan[Common.randomNum(0, _slogan.length - 1)];
            }

            // 如果当前是winner弹出阶段，则点击跳过winnerpop动画
            if (this.gameview == 'popwinner') {
                this.SET_GAME_STATE({
                    key: 'view',
                    value: 'pk'
                });
                // winner弹窗消失
                this.pkFinishedPop();
            }
        },
        // pk结束（winner弹窗之后）
        pkFinishedPop() {
            // winner弹窗消失
            gameAni.hidePop('winner');
            // 是否首次PK，是则弹出来转盘，关闭转盘后弹出来下载引导弹窗（https://app.adjust.com/pa0d860_bafdj4gg）
            // 是否第3次PK，是则弹出来下载引导弹窗弹窗（https://app.adjust.com/zi92y57_laix1w99）
            // 是否达到2000积分，是则弹出来下载引导提示弹窗（https://app.adjust.com/v52y48i_gksiu8y）
            let _userinfo = this.$store.state.userinfo;
            let _pkCount = _userinfo.num_win + _userinfo.num_lose;
            let hasPop200 = Common.getLs('2000tips'); // 是否弹出过2000分提示弹窗
            if (_userinfo.get_gift_battle == 2) {
                // 是否完成首次PK的抽奖
                this.SHOW_POPUP('lottery');
                this.downloadLink = 'https://app.adjust.com/pa0d860_gksiu8y';
            } else if (_pkCount == 2) {
                // 此次PK是第3次，弹出来下载引导弹窗
                this.downloadLink = 'https://app.adjust.com/zi92y57_laix1w9';

                // 弹出下载提示弹窗
                this.popDownload();
            } else if (_userinfo.score_total >= 2000 && !hasPop200) {
                // 达到2000积分，弹出来下载引导提示弹窗
                // 做本地缓存，如果弹出过就不再继续弹
                Common.setLs('2000tips', true);
                this.downloadLink = 'https://app.adjust.com/v52y48i_gksiu8y';

                // 弹出下载提示弹窗
                this.popDownload();
            } else {
                // 都不满足，默认只展示pk文案和结果
                this.SET_GAME_STATE({
                    key: 'view',
                    value: 'pk'
                });
            }
        },
        // 弹出下载提示弹窗
        popDownload() {
            this.showDownloadPop = true;
            this.SET_GAME_STATE({
                key: 'view',
                value: 'popdownload'
            });
            gameAni.popDownload(() => {});
        },
        // 点击下载提示弹窗的下载按钮
        clickDownload() {
            this.PLAY_SOUND('button');
            this.getDownloadScore();
            window.open(this.downloadLink);
        },
        // 弹出战力说明弹窗
        popScoreRule() {
            this.PLAY_SOUND('button');
            this.SHOW_POPUP('powerInfo');
        },
        // 弹出中奖记录
        popRecord() {
            this.PLAY_SOUND('button');
            this.SHOW_POPUP('rewardRecord');
        },
        // 关闭下载弹窗
        closePopDownload() {
            this.PLAY_SOUND('button');
            this.showDownloadPop = false;
            this.SET_GAME_STATE({
                key: 'view',
                value: 'pk'
            });
            gameAni.hidePop('download');
        },
        // 切换游戏界面
        goPage(page, cb) {
            // 切换页面时，清空所有弹窗
            this.HIDE_ALL_POPUP();
            // 页面切换时，清掉pk结果弹窗
            gameAni.hidePop('winner');
            gameAni.hidePop('download');
            // 界面切换
            gameAni.go(page, () => {
                this.SET_GAME_STATE({
                    key: 'view',
                    value: page
                });
                // 游戏内回调
                if (page == 'start') {
                    // 登录前
                    this.SHOW_POPUP('loginTips');
                } else if (page == 'create') {
                    // 生成龙界面
                    gameAni.setUser({
                        name: this.$store.state.game.user_name
                    });
                    gameAni._nameBoxShowStatus(true);
                    // 标签+星座
                    this.setDragonDetail();
                    this.setConstellation();
                    // 底部按钮切换到【领养+确认领养】
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'selectPet'
                    });
                } else if (page == 'home') {
                    // 带slogan的主界面
                    !this.$store.state.createingSharePic && this.viewTap();
                    this.pkwordsData = [];
                    this.SET_GAME_STATE({
                        key: 'canPk',
                        value: true
                    });
                    // 底部按钮切换到【main2】
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'main2'
                    });
                    // 分享提示浮窗
                    this.popShareTips();
                } else if (page == 'share') {
                    // 底部按钮切换到【main1】
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'main1'
                    });
                    this.SET_STATE({
                        key: 'createingSharePic',
                        val: true
                    });
                    this.SET_STATE({
                        key: 'waiting',
                        val: true
                    });
                    this.goPage('home');
                    let _slogan = i18n.t('game.slogan');
                    this.slogan = _slogan[0];
                    // 切换到home，加定时器，避免截图时截取到pk结果页
                    setTimeout(() => {
                        html2canvas(document.querySelector('.game_view')).then(
                            canvas => {
                                let bs64 = canvas.toDataURL('image/jpeg');
                                // window.location.href = bs64;
                                this.gameviewpic = bs64;
                                Bus.$emit('_createSharePic');
                            }
                        );
                    }, 1000);
                } else if (page == 'record1') {
                    // 登录后，无pk记录
                    this.viewTap();
                    this.SET_GAME_STATE({
                        key: 'canPk',
                        value: true
                    });
                    // 底部按钮切换到【main2】
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'main2'
                    });
                } else if (page == 'user') {
                    // 战力页
                    // 底部按钮切换到【main2】
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'main2'
                    });
                    // 登录后是否发起了pk
                    if (gameAni.pkCount > 0) {
                        // 获取用户信息，更新积分
                        gameAni.pkCount = 0;
                        this.getUserInfo();
                    }
                    // 分享提示浮窗
                    this.popShareTips();
                } else if (page == 'empty') {
                    // 空白页
                }

                // 外部回调
                cb && cb();
            });
        },
        // 设置用户昵称
        setUser() {
            gameAni.setUser({
                name: this.$store.state.userinfo
                    ? this.$store.state.userinfo.user_name
                    : '',
                dragonId: this.$store.state.userinfo
                    ? this.$store.state.userinfo.dragon_ename
                    : ''
            });
            this.gameview == 'home' && gameAni._nameBoxShowStatus(true);
        },
        // 更新我的龙
        changeDragon() {
            gameAni.changeDragon(() => {
                // 更新龙昵称
                gameAni.updateNameBox();
                // 八维图
                this.setDragonDetail();
                // 星座
                this.setConstellation();
            });
        },
        // 确认领养龙
        _confirmDragon() {
            // 龙id，标签id，星座id
            if (this.gameview == 'empty') return;
            let _tagsId = this.tags.map((item, index) => {
                return item.id;
            });
            this.confirmDragon({
                // 龙id
                id: gameAni.getDragonDataById(gameAni.myDragonId).id,
                // 标签id
                tag_id: _tagsId.join(','),
                // 星座id
                star_id: this.constellation.id
            });
        },
        // 重播
        replayPk(enemy, pkWords, immediately) {
            let _this = this;
            if (!gameAni.canPk) return;
            this.pkwordsData = [];
            this.SET_GAME_STATE({
                key: 'canPk',
                value: false
            });
            this.SET_GAME_STATE({
                key: 'view',
                value: 'pk'
            });
            this.SET_STATE({
                key: 'toolbarType',
                val: ''
            });
            this.STOP_SOUND();
            setTimeout(() => {
                this.PLAY_SOUND('battle');
            }, 300);
            gameAni.replay(
                enemy,
                pkWords,
                msg => {
                    // 对战过程
                    this.pkwordsData.push(msg);
                    setTimeout(() => {
                        // 滚动条贴底
                        this.$refs.pklist.scrollTop = this.$refs.pklist.scrollHeight;
                    }, 30);
                },
                () => {
                    this.STOP_SOUND();
                    this.checkBgm();
                    // 对战结束
                    // console.log('对战结束');
                    this.SET_GAME_STATE({
                        key: 'canPk',
                        value: true
                    });
                    // 底部按钮切换到main2
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: 'main2'
                    });
                    // 分享提示浮窗
                    this.popShareTips();
                },
                immediately
            );
        },
        // 开始pk
        startPk(enemy) {
            // console.log('发起PK', enemy);
            let _this = this;
            if (!gameAni.canPk) return;
            let _pkWords = gameAni.createPkWords();
            // 发起pk请求，成功后开始播放PK动画
            this.getBattleResult({
                object_type_id: enemy ? 2 : 1, // 1 NPC 2 好友
                object_id: enemy ? enemy.user_id : 36, // NPC是否必传
                tag_id: enemy ? '' : '4,34,38,32,22,18,12,8', // 标签ID
                star_id: enemy ? '' : 1, // 星座ID
                content_battle_id: _pkWords.ids //对战文案ID
            }).then(res => {
                // console.log('pk结果', res);
                if (res.code == 1) {
                    let _score_add = Number(res.data.get_score); // 本次pk获得积分
                    let _score_total = Number(
                        this.$store.state.userinfo.score_total
                    );
                    let _score = Number(this.$store.state.userinfo.score);
                    this.SET_USERINFO({
                        score_total: _score_total + _score_add,
                        score: _score + _score_add
                    });
                    // 成功时，开始PK
                    this.pkwordsData = [];
                    this.SET_GAME_STATE({
                        key: 'canPk',
                        value: false
                    });
                    this.SET_GAME_STATE({
                        key: 'view',
                        value: 'pk'
                    });
                    this.SET_STATE({
                        key: 'toolbarType',
                        val: ''
                    });
                    // 胜负
                    let _enemy = enemy ? enemy : {};
                    _enemy.winner = res.data.status == 2; // 1主队胜，2对手胜
                    this.STOP_SOUND();
                    setTimeout(() => {
                        this.PLAY_SOUND('battle');
                    }, 300);
                    // console.error('把测试时的快速PK关闭')

                    gameAni.pk(
                        _enemy,
                        _pkWords,
                        msg => {
                            // 对战过程
                            this.pkwordsData.push(msg);
                            setTimeout(() => {
                                // 滚动条贴底
                                this.$refs.pklist.scrollTop = this.$refs.pklist.scrollHeight;
                            }, 30);
                        },
                        () => {
                            this.STOP_SOUND();
                            this.checkBgm();
                            this.PLAY_SOUND('victory');
                            // 对战结束
                            // console.log('对战结束');
                            // 分享提示浮窗
                            this.popShareTips();
                            // winner loser闪完再出winner弹窗
                            setTimeout(() => {
                                this.SET_GAME_STATE({
                                    key: 'canPk',
                                    value: true
                                });
                                // 底部按钮切换到main1
                                this.SET_STATE({
                                    key: 'toolbarType',
                                    val: 'main1'
                                });
                                // 先隐藏pk文案记录
                                this.SET_GAME_STATE({
                                    key: 'view',
                                    value: 'popwinner'
                                });
                                // 弹出winner弹窗
                                gameAni.popWinner(() => {
                                    this.SET_GAME_STATE({
                                        key: 'view',
                                        value: 'pk'
                                    });
                                    // winner弹窗消失
                                    this.pkFinishedPop();
                                });
                            }, 1500);
                        }
                    );
                } else {
                    // console.log('pk失败', res.msg);
                    if (res.code == 213) {
                        // alert(i18n.t('msg.pklimit'));
                        this.showComm({
                            text: i18n.t('msg.pklimit'),
                            size: 'mid'
                        });
                        if (this.gameview == 'friend') {
                            // 可能超出同好友pk次数限制（3次）
                            // alert(i18n.t('msg.pklimit'));
                        } else {
                            // 超过限制回到首页
                            this.goPage('home');
                        }
                    }
                }
            });
        },
        // 背景音播放状态
        checkBgm() {
            let _bgmState = this.$store.state.bgmPlayState;
            let _volume = this.$store.state.bgmVolume;
            if (_bgmState) {
                createjs.Sound.play('bgm', {
                    loop: -1,
                    volume: _volume
                });
            } else {
                createjs.Sound.stop();
            }
        },
        // 初始化用户信息
        initUserData() {
            // 设置昵称
            this.setUser();
            // 标签
            this.setDragonDetail(this.$store.state.userinfo.tags);
            // 星座
            this.setConstellation({
                id: this.$store.state.userinfo.star_id,
                name: this.$store.state.userinfo.star_name,
                ename: this.$store.state.userinfo.star_ename
            });
        },
        // 处理标签数据
        handleTags() {
            let _tags = this.$store.state.game.tags;
            this.tagsData = {
                tags1: _tags.filter(item => item.type_id == 1), // 元素
                tags2: _tags.filter(item => item.type_id == 2) // 招式
            };
        },
        // 设置龙面板内容
        setDragonDetail(tags) {
            // 绘制图表(1元素+7招式)
            let allTagsData = this.tagsData;
            let _tags = tags
                ? tags
                : Common.getRandomArrayValue(allTagsData.tags1, 1).concat(
                      Common.getRandomArrayValue(allTagsData.tags2, 7)
                  );
            this.tags = _tags;
        },
        // 星座
        setConstellation(constellation) {
            let _stars = this.$store.state.game.star;
            this.constellation = constellation
                ? constellation
                : _stars[Common.randomNum(0, _stars.length - 1)];
        },
        // 初始化界面
        initPage() {
            let _userid = getQueryString('userid');
            let _username = getQueryString('username');
            let _dragonid = getQueryString('dragonid');
            // 初始化用户信息
            this.initUserData();
            // 链接是否有好友参数（有则发起好友PK），且链接携带的id是否玩家自己的
            if (
                _userid &&
                _userid != this.$store.state.userinfo.id &&
                _username &&
                _dragonid
            ) {
                // 链接是否有好友参数（有则发起好友PK）
                let _friendDragon = gameAni.getDragonDataByTrueId(_dragonid);
                setTimeout(() => {
                    // 如果与该好友pk超过次数限制，会直接前往home页
                    this.startPk({
                        id: _friendDragon.ename,
                        name: Base64.decode(_username),
                        user_id: _userid
                    });
                }, 1000);
            } else {
                // 获取最近PK记录，和本地缓存对比（时间戳）
                this.checkPkHistory();
            }
        },
        // 检查是否有历史pk记录
        checkPkHistory() {
            // 我的用户id
            let _myUserid = this.$store.state.userinfo.id;
            // 是否有pk记录
            this.getBattleHistoryList({
                type: 2, // 別人对我发起pk的记录
                user_id: _myUserid,
                sort: 1, // 顺序0倒序1
                page: 1,
                size: 1
            }).then(res => {
                // console.log('历史pk记录', res);
                // 请求成功
                if (res.code == 1) {
                    // 根据记录判断前往哪个界面
                    let _last = Common.getLs('pkrecord');
                    let _hasNewRecord =
                        _last &&
                        res.data.length != 0 &&
                        res.data[0].create_time != _last;
                    if (
                        (res.data.length != 0 && _last && _hasNewRecord) ||
                        (res.data.length != 0 && !_last)
                    ) {
                        // 更新本地记录的pk时间
                        Common.setLs('pkrecord', res.data[0].create_time);
                        let _replayData = res.data[0];
                        let _pkWordsData = {
                            ids: _replayData.content_id.join(','),
                            words: gameAni.content2pkWords(_replayData.content)
                        };
                        let _player2Data = gameAni.handlePkData(
                            _replayData,
                            _myUserid
                        );
                        // 有pk记录。发起快速pk
                        this.replayPk(
                            _player2Data.player2,
                            _pkWordsData,
                            true // 快速重播
                        );
                    } else {
                        // 无记录
                        this.goPage('record1');
                    }
                } else {
                    // 失败，直接前往home
                    this.goPage('home0');
                }
            });
        },
        // 处理pk数据
        handlePkData(pkdata) {
            // 我的用户id
            let _myUserid = this.$store.state.userinfo.id;
            // pkdata
            let _player1_id = pkdata.user_id; // 主动发起攻击的玩家
            let _player2_id = pkdata.object_id; // 被攻击的玩家

            let _player2_data = {}; // 对面玩家
            if (_myUserid == _player1_id) {
                // 数据不需要反转。正常播放即可
                _player2_data = {
                    player1: {}, // 暂不需要
                    player2: {
                        id: pkdata.dragon_ename_object,
                        name: pkdata.object_name,
                        winner: pkdata.status == 2 // 是否胜利（玩家自己的胜利状态：1胜利 2失败，statys=2时，对手胜利）
                    }
                };
            } else if (_myUserid == _player2_id) {
                // 我是被攻击的一方，需要反转数据
                _player2_data = {
                    player1: {}, // 暂不需要
                    // 返回player2玩家数据
                    player2: {
                        id: pkdata.dragon_ename,
                        name: pkdata.user_name,
                        winner: pkdata.status == 1
                    }
                };
            }

            return _player2_data;
        }
    },
    mounted() {
        // eventBus
        Bus.$on('_eventBusDemo', () => {
            // console.log('eventBus demo');
        });
        // 初始化界面
        Bus.$on('_initPage', () => {
            this.initPage();
        });
        // 前往page
        Bus.$on('_goPage', (page, cb) => {
            this.goPage(page, cb);
        });
        // 初始化用户信息
        Bus.$on('_initUserData', () => {
            this.initUserData();
        });
        // 设置用户昵称
        Bus.$on('_setUser', () => {
            this.setUser();
        });
        // 设置标签数据
        Bus.$on('_handleTags', () => {
            // 处理标签数据
            this.handleTags();
        });
        // 换一只领养
        Bus.$on('_changeDragon', () => {
            this.changeDragon();
        });
        // 确认领养
        Bus.$on('_confirmDragon', () => {
            this._confirmDragon();
        });
        // 确认领养并对战
        Bus.$on('_startPk', enemy => {
            // 不带参数，则跟NPC对战
            // 带玩家参数（敌方），则跟玩家PK
            this.startPk(enemy);
        });
        // 重播
        Bus.$on('_replayPk', (enemy, pkWords) => {
            this.replayPk(enemy, pkWords);
        });
        // 弹出下载提示弹窗
        Bus.$on('_popDownload', () => {
            this.popDownload();
        });
    }
};
</script>

<style lang="less" scoped>
@import '../assets/style/gameview.less';
</style>
